import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { BiImageAdd } from "react-icons/bi";
import { BsImage } from "react-icons/bs";
import useDialogState, { Loader } from "../../hook";
import Parallax4DImageService from "../../services/parallax4D.service";
import { notifyError, notifySuccess } from "../../hook/notification";
import * as yup from "yup";
import CategoryService from "../../services/category.service";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { MdDeleteOutline } from "react-icons/md";
import liveWallpaperService from "../../services/livewallpaper.service";
import NotificationService from "../../services/notification.service";
import CollectionService from "../../services/collection.service";

// Custom Dropdown component
const Dropdown = ({ options, onSelect, selectedValue }) => {
  const menuRef = useRef();
  const [toggleShow, setToggleShow] = useState(false);

  const userToggle = () => {
    setToggleShow((prev) => !prev);
  };

  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setToggleShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="flex flex-col gap-2 relative">
      <div onClick={userToggle} className="input cursor-pointer">
        {selectedValue === "" ? "Select" : selectedValue}
      </div>
      <div
        className={`${
          toggleShow ? "block" : "hidden"
        } bg-gray-800 rounded-6 overflow-hidden absolute top-[40px] w-full z-70 min-h-10 max-h-52 h-auto overflow-y-auto`}
      >
        {options.length > 0 ? (
          options.map((option, index) => (
            <p
              key={index}
              onClick={() => {
                onSelect(option.label, option.value);
                setToggleShow(false);
              }}
              className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white"
            >
              {option.label}
            </p>
          ))
        ) : (
          <p className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white">
            No data found
          </p>
        )}
      </div>
    </div>
  );
};

const Wallpaper = () => {
  const menuRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const hiddenFileInput = useRef(null);
  const [data, setData] = useState([]);
  const [showVal, setShowVal] = useState("NON PREMIUM");
  const [showVal2, setShowVal2] = useState("");
  const [showVal3, setShowVal3] = useState("");
  const [fileName, setFileName] = useState(["", "", ""]);
  const [fileNamePreview, setFileNamePreview] = useState("");
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState(false);
  const [imageUpdate, setImageUpdate] = useState(false);
  const [collectionData, setCollectionData] = useState([]);

  const sendNotification = (e) => {
    setNotification(e.target.checked);
  };

  const toggle = () => {
    setOpen(!open);
  };

  const [tagInput, setTagInput] = useState("");
  const [tags, setTags] = useState([]);

  const handleTagInputChange = (e) => {
    setTagInput(e.target.value);
  };

  const handleAddTag = () => {
    if (tagInput.trim() !== "") {
      if (tags === null || tags.length === 0) {
        setTags([tagInput.trim()]);
      } else {
        setTags([...tags, tagInput.trim()]);
      }
      setTagInput("");
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    const updatedTags = tags.filter((tag) => tag !== tagToRemove);
    setTags(updatedTags);
  };

  const {
    loader: loader,
    handleClickOpen: setLoader,
    handleClose: unSetLoader,
  } = useDialogState();

  const handleSelect = (value, id) => {
    setShowVal(value);
    formik.setFieldValue("premium", id === "PREMIUM" ? true : false);
  };

  const handleSelect2 = (value, id) => {
    setShowVal2(value);
    formik.setFieldValue("categoryId", id);
  };

  const handleSelect3 = (value, id) => {
    setShowVal3(value);
    formik.setFieldValue("collectionId", id);
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleChangePreview = (event) => {
    const fileUploaded = event.target.files[0];
    formik.setFieldValue("previewImage", fileUploaded);
    setFileNamePreview(fileUploaded);
  };

  const ImageType = [
    { value: "PREMIUM", label: "PREMIUM" },
    { value: "NON PREMIUM", label: "NON PREMIUM" },
  ];

  const getAllData = async () => {
    const response = await CategoryService.GetAllCategory(0, 0);
    const data = response.data.apiresponse.data;
    setData(data.categories);
  };

  const getAllCollectionData = async () => {
    try {
      const response = await CollectionService.GetAllCollection(0, 0);
      const data = response.data.apiresponse.data;
      setCollectionData(data?.collections);
    } catch (error) {
      console.log("🚀  getAllCollectionData  error:", error);
    }
  };

  useEffect(() => {
    getAllData();
    getAllCollectionData();
  }, []);

  const CategoryOption = data.map((item) => {
    return {
      label: item.categoryName,
      value: item.id,
    };
  });

  const CollectionOption = collectionData.map((item) => {
    return {
      label: item.collectionName,
      value: item.id,
    };
  });

  useEffect(() => {
    if (location.state !== null) {
      const data = location.state;
      formik.setFieldValue("imageId", data.imageId);
      formik.setFieldValue("premium", data.premium);
      setShowVal(data.isPremium === true ? "PREMIUM" : "NON PREMIUM");
      formik.setFieldValue("multimediaType", data.multimediaType);
      formik.setFieldValue("imageName", data.imageName);
      setTags(data.tags);
      setFileNamePreview(
        data.url.split("/").pop().split("-").slice(1).join("-")
      );
      if (data.parallax4DList.length > 0) {
        setFileName(
          data.parallax4DList.map((item) =>
            item.split("/").pop().split("-").slice(1).join("-")
          )
        );
      }
      if (CategoryOption.length > 0 && data.categoryId) {
        const abcd = CategoryOption.find(
          (item) => item.value === data.categoryId
        );
        if (abcd) {
          formik.setFieldValue("categoryId", abcd.value);
          setShowVal2(abcd.label);
        }
      }
      if (CollectionOption?.length > 0 && data.collectionId) {
        const abcd = CollectionOption.find(
          (item) => item.value === data.collectionId
        );
        if (abcd) {
          formik.setFieldValue("collectionId", abcd.value);
          setShowVal3(abcd.label);
        }
      }
    }
  }, [location, data]);

  const initialValue = {
    imageId: "",
    categoryId: "",
    imageName: "",
    premium: false,
    previewImage: "",
    image: "",
    tags: [],
    multiFile: [],
    collectionId: "",
  };

  const schema = yup.object().shape({
    imageName: yup.string().required("Please enter image name"),
    previewImage:
      location.state === null && yup.mixed().required("Please select image"),
    premium: yup.boolean().required("Please select image type"),
    // categoryId: yup.string().required("Please select image category"),
  });

  const submit = async (values, action) => {
    const {
      categoryId,
      imageName,
      premium,
      previewImage,
      imageId,
      collectionId,
    } = values;
    try {
      const fileData = new FormData();
      const emptyFile = new File([""], "empty.txt", { type: "text/plain" });
      fileData.append(
        "liveWallpaper",
        previewImage !== "" ? previewImage : emptyFile
      );
      fileData.append("categoryId", categoryId || 0);
      fileData.append("imageName", imageName);
      fileData.append("premium", premium);
      fileData.append("collectionId", collectionId || 0);
      if (tags !== null) {
        fileData.append("tags", tags);
      }
      if (imageId) {
        fileData.append("id", imageId);
      }
      fileData.append("sendNotification", notification);
      setLoader();
      await liveWallpaperService.createLiveImage(fileData);
      // if (notification) {
      //   await NotificationService.sendNotification(notification);
      // }
      notifySuccess(
        imageId
          ? "Live wallpaper update successfully"
          : "Live wallpaper create successfully"
      );
      setImageUpdate(false);
      setTimeout(() => {
        setFileName("");
        unSetLoader();
        navigate("/images");
        action.resetForm();
      }, 1500);
    } catch (error) {
      console.error("error", error);
      notifyError("Something went wrong");
      setTimeout(() => {
        setFileName("");
        unSetLoader();
        navigate(-1);
        action.resetForm();
      }, 1500);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  return (
    <>
      <div
        className="max-w-[900px] min-w-[300px] w-auto px-5 pb-10"
        ref={menuRef}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="pt-10">
            <h1 className="text-base font-semibold leading-7 text-white pb-5">
              Live Wallpapers
            </h1>
            <div className="pb-2">
              <button onClick={toggle} type="button" className="btn save w-40">
                Add Tags
              </button>

              {open && (
                <div className="fixed inset-0 bg-[black]/60 z-[999] overflow-y-auto">
                  <div
                    className="flex items-center justify-center min-h-screen px-4"
                    // onClick={() => setOpen(false)}
                  >
                    <div className="bg-white overflow-hidden rounded-6 p-5 lg:p-7 max-w-[500px] w-full min-w-[350px]">
                      <h1 className="font-medium mb-5">Adding Title</h1>
                      <div className="flex flex-col gap-2 mb-7">
                        <label className="text-sm font-medium">Tag Title</label>
                        <input
                          className="bg-white w-full py-1.5 px-3 rounded-6 focus:outline-none border border-blue"
                          type="text"
                          placeholder="Enter Tag Name..."
                          value={tagInput}
                          onChange={handleTagInputChange}
                        />
                        <button
                          className="bg-blue w-full p-2 rounded-6 text-white font-medium"
                          onClick={handleAddTag}
                          type="button"
                        >
                          Add Tag
                        </button>
                      </div>
                      {tags &&
                        tags.length > 0 &&
                        tags.map((tag, index) => (
                          <div key={index} className="border rounded-6 mb-1">
                            <div className="grid grid-cols-4 items-center border-b px-3 py-1.5">
                              <div className="col-span-3">
                                <span className="text-sm">{tag}</span>
                              </div>
                              <div className="col-span-1 flex justify-end border-l">
                                <button
                                  className="bg-red/80 text-white text-sm font-medium rounded-6 py-1.5 px-2.5"
                                  onClick={() => handleRemoveTag(tag)}
                                  type="button"
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      <div className="flex justify-end gap-4 items-center mt-7">
                        <button
                          onClick={() => (
                            setOpen(false), setTags([]), setTagInput("")
                          )}
                          type="button"
                          className="border border-red/80 text-red/80 font-medium rounded-6 py-1.5 px-2.5 w-full"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => setOpen(false)}
                          type="button"
                          className="bg-blue text-white font-medium rounded-6 py-1.5 px-2.5 w-full"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="my-3">
                {!open &&
                  tags !== null &&
                  tags.length > 0 &&
                  tags.map((tag, index) => (
                    <div className="flex items-center justify-between text-white py-1.5 px-3 rounded-full border-blue border mb-1">
                      {tag}
                      <MdDeleteOutline
                        onClick={() => handleRemoveTag(tag)}
                        className="text-red text-2xl cursor-pointer"
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Name</label>
            <input
              className="input"
              name="imageName"
              placeholder="image name"
              value={formik.values.imageName}
              onChange={formik.handleChange}
              type="text"
            />
            {formik.errors.imageName && formik.touched.imageName && (
              <div className="text-red text-sm">{formik.errors.imageName}</div>
            )}
          </div>

          {/* First Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Type</label>
            <Dropdown
              options={ImageType}
              onSelect={(value, id) => handleSelect(value, id)}
              selectedValue={showVal}
            />
            {formik.errors.premium && formik.touched.premium && (
              <div className="text-red text-sm">{formik.errors.premium}</div>
            )}
          </div>

          {/* Second Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Category</label>
            <Dropdown
              options={CategoryOption}
              onSelect={(value, id) => handleSelect2(value, id)}
              selectedValue={showVal2}
            />
            {formik.errors.categoryId && formik.touched.categoryId && (
              <div className="text-red text-sm">{formik.errors.categoryId}</div>
            )}
          </div>

          {/* Third Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Collection</label>
            <Dropdown
              options={CollectionOption}
              onSelect={(value, id) => handleSelect3(value, id)}
              selectedValue={showVal3}
            />
            {formik.errors.collectionId && formik.touched.collectionId && (
              <div className="text-red text-sm">
                {formik.errors.collectionId}
              </div>
            )}
          </div>

          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Preview Image</label>
            <div className="flex items-center gap-5">
              <input type="image" accept="image/*" id="upload" alt="" hidden />
              <label
                onClick={handleClick}
                className="border border-white rounded-6 flex items-center justify-center flex-col gap-5 p-4 cursor-pointer w-full lg:p-10 text-center"
              >
                <BsImage className="text-gray-600 text-5xl" />
                <span className="text-white text-sm  ">
                  {!fileNamePreview ? (
                    <>
                      <span className="text-center">
                        <strong>Upload a file</strong> or drag and drop <br />
                        mp4
                      </span>
                    </>
                  ) : (
                    fileNamePreview?.name || fileNamePreview
                  )}
                </span>
              </label>
              <input
                type="file"
                onChange={handleChangePreview}
                ref={hiddenFileInput}
                className="hidden"
                accept="video/*"
                multiple={false}
              />
            </div>
            {formik.errors.previewImage && formik.touched.previewImage && (
              <div className="text-red text-sm mb-4">
                {formik.errors.previewImage}
              </div>
            )}
          </div>
          <div className="flex items-center">
            <input
              type="checkbox"
              id="notificaiton"
              className="p-3"
              onChange={sendNotification}
            />
            <label
              htmlFor="notificaiton"
              className="text-white ps-4 cursor-pointer"
            >
              Send Notification
            </label>
          </div>
          <div className="flex justify-end gap-4 items-center">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn cancel"
            >
              Cancel
            </button>
            <button type="submit" className="btn save">
              {loader ? <Loader /> : "Save"}
            </button>
          </div>
        </form>
        <ToastContainer autoClose={1500} />
      </div>
    </>
  );
};

export default Wallpaper;
